import {useContext, useEffect, useState} from "react";
import {AuthContext} from "./AuthContext";
import QRCode from "react-qr-code";
import DateHelper from "../../../services/DateHelper";

const QrCode = props => {
  const { member } = useContext(AuthContext);
  const [barcode, setBarcode] = useState(member.barcode);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const date = DateHelper.createDate(new Date());

      const newBarcode = !member.club.with_rotating_qr_code ? member.barcode : `${member.barcode}/MemberPortal/${DateHelper.toQrFormat(date)}`;
      console.log(newBarcode);
      setBarcode(newBarcode);
    }, 15000);

    return () => clearTimeout(timeoutId);
  }, [barcode]);

  return (
    <div className="qrcode">
      <QRCode value={barcode} />
    </div>
  )
};

export default QrCode;